import { createAsyncThunk } from "@reduxjs/toolkit";

import apiRequest from "../../../services/api";
import { validatePearlsDetails } from "../../features/feed/pearlSlice";

export const listPearls = createAsyncThunk(
  "feed/list_pearls",
  async (body, { rejectWithValue }) => {
    let query = `page=${body.page ? body.page : 1}&`;
    if (body.page_size) {
      query = query + `page_size=${body.page_size}&`;
    }
    if (body.search) {
      query = query + `search=${body.search}&`;
    }
    if (body.orderby) {
      query = query + `ordering=${body.orderby}&`;
    }
    if (body.no_of_sub_dx) {
      query = query + `no_of_sub_dx=${body.no_of_sub_dx}&`;
    }
    if (body.categories) {
      query = query + `categories=${body.categories}&`;
    }
    try {
      const pearls = await apiRequest.get(`v1/pearls/?${query}`, {
        headers: { organization: body.userOrganization.org_id },
      });
      return pearls.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const createPearls = createAsyncThunk(
  "feed/create_pearls",
  async (body, { getState, rejectWithValue, dispatch }) => {
    dispatch(validatePearlsDetails());
    const state = getState();
    const pearlValidationErrors = state.pearls.pearlValidationErrors;
    if (Object.keys(pearlValidationErrors).length > 0) {
      return rejectWithValue(pearlValidationErrors);
    }
    const pearl_sub_dx = body.newPearlsData.pearl_sub_dx.filter(
      (val) => val.title || val.definition || val.requirements
    );
    try {
      const newPearls = await apiRequest.post(
        `v1/pearls/`,
        { ...body.newPearlsData, pearl_sub_dx },
        {
          headers: { organization: body.userOrganization.org_id },
        }
      );
      return newPearls;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const updatePearls = createAsyncThunk(
  "feed/update_pearls",
  async (body, { getState, rejectWithValue, dispatch }) => {
    dispatch(validatePearlsDetails());
    const state = getState();
    const pearlValidationErrors = state.pearls.pearlValidationErrors;
    if (Object.keys(pearlValidationErrors).length > 0) {
      return rejectWithValue(pearlValidationErrors);
    }
    const pearl_sub_dx = body.newPearlsData.pearl_sub_dx.filter(
      (val) => val.title || val.definition || val.requirements
    );
    try {
      const newPearls = await apiRequest.patch(
        `v1/pearls/${body.pearlsId}/`,
        { ...body.newPearlsData, pearl_sub_dx },
        {
          headers: { organization: body.userOrganization.org_id },
        }
      );
      return newPearls;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const deletePearls = createAsyncThunk(
  "feed/delete_pearls",
  async (body, { rejectWithValue }) => {
    try {
      const pearlsDelete = await apiRequest.delete(
        `v1/pearls/${body.pearlsId}/`,
        {
          headers: { organization: body.userOrganization.org_id },
        }
      );
      return pearlsDelete.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const fetchPearlsDetails = createAsyncThunk(
  "feed/fetch_pearls_details",
  async (body, { rejectWithValue }) => {
    try {
      const pearlsDetails = await apiRequest.get(
        `v1/pearls/${body.pearlsId}/`,
        {
          headers: { organization: body.userOrganization.org_id },
        }
      );
      return pearlsDetails.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const duplicatePearls = createAsyncThunk(
  "feed/duplicate_pearls",
  async (body, { rejectWithValue }) => {
    try {
      const pearlsDuplicate = await apiRequest.post(
        `v1/pearls/${body.pearlsId}/duplicate/`,
        { title: body.title },
        {
          headers: { organization: body.userOrganization.org_id },
        }
      );
      return pearlsDuplicate;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);
